import { createContext } from 'react';

const SessionConsumptionContext = createContext();

export default SessionConsumptionContext;